import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { CATEGORIES, fmtTL } from "@/lib/api";
import { AlertTriangle, Clock, CalendarClock, BellRing } from "lucide-react";

export default function NotificationDrawer({ open, onClose, notifs }) {
  const requestBrowserNotify = () => {
    if (!("Notification" in window)) return;
    Notification.requestPermission().then((perm) => {
      if (perm === "granted" && notifs.length > 0) {
        const n = notifs[0];
        new Notification("VİLAYET - Ödeme Hatırlatması", {
          body: `${CATEGORIES[n.category]?.label || n.title}: ${fmtTL(n.amount)} ${
            n.days_left < 0 ? "gecikmiş!" : n.days_left === 0 ? "bugün ödenmeli!" : `${n.days_left} gün kaldı`
          }`,
        });
      }
    });
  };

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent className="bg-[#0D1220] border-slate-800 w-full sm:max-w-md" data-testid="notification-drawer">
        <SheetHeader>
          <SheetTitle className="font-heading text-white flex items-center gap-2">
            <BellRing className="w-5 h-5 text-blue-400" />
            Ödeme Günü Bildirimleri
          </SheetTitle>
        </SheetHeader>

        <div className="mt-6 space-y-3 overflow-y-auto max-h-[calc(100vh-160px)] pr-1">
          {notifs.length === 0 && (
            <div className="text-center py-16 text-slate-500 text-sm">
              Yaklaşan ödeme bulunmuyor. Her şey yolunda! ✅
            </div>
          )}
          {notifs.map((n) => {
            const overdue = n.days_left < 0;
            const today = n.days_left === 0;
            const cat = CATEGORIES[n.category] || CATEGORIES.diger;
            return (
              <div
                key={n.id}
                data-testid={`notif-item-${n.id}`}
                className={`rounded-xl p-4 border ${
                  overdue
                    ? "bg-rose-500/10 border-rose-500/40"
                    : today
                    ? "bg-amber-500/10 border-amber-500/40"
                    : "bg-slate-800/50 border-slate-700/60"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <span className="w-2.5 h-2.5 rounded-full" style={{ background: cat.color }} />
                    <div>
                      <div className="text-sm font-semibold text-white">{n.title}</div>
                      <div className="text-xs text-slate-400">{cat.label}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono font-semibold text-white text-sm">{fmtTL(n.amount)}</div>
                  </div>
                </div>
                <div className="mt-3 flex items-center gap-1.5 text-xs">
                  {overdue ? (
                    <span className="flex items-center gap-1 text-rose-400 font-medium">
                      <AlertTriangle className="w-3.5 h-3.5" /> {Math.abs(n.days_left)} gün gecikmiş
                    </span>
                  ) : today ? (
                    <span className="flex items-center gap-1 text-amber-400 font-medium">
                      <Clock className="w-3.5 h-3.5" /> Bugün ödenmeli
                    </span>
                  ) : (
                    <span className="flex items-center gap-1 text-slate-400">
                      <CalendarClock className="w-3.5 h-3.5" /> {n.days_left} gün kaldı ({n.due_date})
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <button
          data-testid="enable-push-button"
          onClick={requestBrowserNotify}
          className="mt-6 w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-colors flex items-center justify-center gap-2"
        >
          <BellRing className="w-4 h-4" /> Telefon Bildirimlerini Aç
        </button>
      </SheetContent>
    </Sheet>
  );
}
